import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation,useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState();
  const [valueOCR, setValueOCR] = useState("");
  const [file, setFile] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenRefuse, toggleModalRefuse] = useState(false);
  const [data, setData] = useState();
  const [idIsee, setIdIsee] = useState();



  let query = useQuery();

  useEffect(() => {  
    setLoading(false);
    if (query.get("idIsee")) {
      setIdIsee(query.get("idIsee"));
      Repo.getIsee(apiToken, query.get("idIsee"))
        .then((response) => {
          if (response.status == 200) {
            var obj = document.createElement("object");
            obj.type = "application/pdf";
            obj.data = "data:application/pdf;base64," + response.data.file;
            setFile(obj);
            setUserData(response.data.user);
            setValue(response.data.value);
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
   
      Repo.postValueIseeOCR(apiToken, query.get("idIsee"))
        .then((response) => {
          if (response.status == 200) {

            var valueWithoutComma = response.data.replace('.', '');
            var valueWithoutComma2 = valueWithoutComma.replace(',', '.');
console.log("valueWithoutComma2:" + valueWithoutComma2);
            // Effettua il parsing del valore come float
           var floatValue = parseFloat(valueWithoutComma2);
           console.log("floatValue:" + floatValue);
            // Formatta il numero in una rappresentazione locale italiana
            var formattedValue = floatValue.toLocaleString('it-IT');
            console.log("formattedValue:" + formattedValue);
            setValueOCR(floatValue);
          }
          setLoading(true);
        })
        .catch((error) => {
          console.log(error.message);
          setLoading(true);
        });
    }
  }, []);

  const confirmIsee = async () => {
    setValidation(true);
    let tempData = {};
    let passedValidation = true;

    tempData["id"] = idIsee;

    if (value == "" || value == " " || !value) passedValidation = false;

    tempData["value"] =
      typeof value == "string"
        ? value.replace(".", "").replace(",", ".")
        : value;

    tempData["state"] = 1;

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);

      setData(dataJson);
      if (!props.apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const refuseIsee = async () => {
    setValidation(true);
    let tempData = {};
    let passedValidation = true;
    tempData["id"] = idIsee;
    tempData["state"] = 2;
    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (!props.apiToken) {
        toggleModalRefuse(!isOpenRefuse);
      }
    }
  };

  const sendISEEApi = async () => {
    Repo.postConfirmIsee(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/lista_isee";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  const history = useHistory();
  return (
    <>
      <div>
         <h1>Verifica ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Verifica gli ISEE caricati dagli utenti confronta il valore inserito con quello estratto dal documento PDF</p>
          </div>


        <div className="row mb-2">
          <div className="col-12">
         




          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <object
              width="100%"
              height="900"
              data={file && file.data}
              type="application/pdf"
            ></object>
          </div>

          <div className="col-lg-4 pl-5">


                <h3>Riepilogo utente</h3>
                 
                    <div>
                      Nome cognome: 
                      <div className="clear"></div>
                      <strong>{userData && userData.firstName + " " + userData.lastName}</strong>
      
                      <div className="clear"></div>
                  
                      Codice Fiscale:{" "}
                      <div className="clear"></div>
                      <strong>{userData && userData.fiscalCode}</strong>
                      <div className="clear"></div>
                      Email: 
                      <div className="clear"></div>
                      <strong>{userData && userData.email}</strong>
                 

                    </div>
         
<hr/>

                    <div className="clear"></div>

                  <p className="mt-2">Valore ISEE Estratto in automatico:</p>
                  <div className="row mb-4">
                    <Input
                      id="value"
                      type="text"
                      disabled
                      value={
                        valueOCR && valueOCR
                          ? parseFloat(valueOCR).toLocaleString("it-IT")
                          : ""
                      }
                    />
                  </div>
                  <div className="d-flex p-2 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-icon btn-outline-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() =>
                      setValue(parseFloat(valueOCR).toLocaleString("it-IT"))
                    }
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-arrow-down`}></use>
                    </svg>
                    Copia valore
                  </button>
                  </div>
                  <p className="mt-2">ISEE Dichiarato*</p>
                  <div className="row mb-4">
                    <Input
                      id="value"
                      infoText="Valore inserito dall'utente in fase di caricamento ISEE"
                      value={value && value ? value.toString() : ""}
                      name="Valore ISEE"
                      onChange={(e) => setValue(e.target.value)}
                      {...(validation &&
                        (value == "" || value == " ") && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div",
                        })}
                    />
                  </div>
                  <div className="d-flex justify-content-around">
                    <div>
                      <button
                        type="button "
                        className="btn btn-success"
                        data-toggle="tooltip"
                        data-placement="top"
                        onClick={() => confirmIsee()}
                        title="Conferma"
                      >
                        Conferma
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-warning"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Rifiuta"
                        onClick={() => refuseIsee()}
                      >
                        Rifiuta
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Indietro"
                        onClick={() => history.goBack()}
                      >
                        Indietro
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRefuse}
        isOpen={isOpenRefuse}
        header="Rifiuto ISEE"
        body="Confermi di voler rifiutare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>

      {!loading && (
        <div className="col-12">
          <div className="trasparente">
            <div className="progress-spinner progress-spinner-active spinner"></div>
            <span className="customTextSpinnerIsee">
              Elaborazione valore ISEE...
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default CheckISEE;
